import { render } from "./NcrmPrivacyDashboard.vue?vue&type=template&id=c582ffb4&scoped=true"
import script from "./NcrmPrivacyDashboard.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyDashboard.vue?vue&type=script&lang=js"

import "./NcrmPrivacyDashboard.vue?vue&type=style&index=0&id=c582ffb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c582ffb4"]])

export default __exports__